<div *ngIf="formGroup; else noSearchHeader" [formGroup]="formGroup">
  <div class="d-flex flex-column gap-1">
    <button type="button" class="header-title no-style-button" (click)="toggleSort()">
      <span class="column-name">{{ columnName }}</span>
      <span *ngIf="isAscSort$ | async" class="visually-hidden" i18n>, sorted ascending</span>
      <span *ngIf="isDescSort$ | async" class="visually-hidden" i18n>, sorted descending</span>
      <span class="sort-arrow">
        <img *ngIf="sortIconSrc$ | async" [src]="sortIconSrc$ | async" alt="" />
        <img *ngIf="!(sortIconSrc$ | async)" [src]="'assets/icons/grey/Arrow-Down.svg'" alt="" />
      </span>
    </button>
    <div [ngbCollapse]="!(showSearchBar$ | async) ?? false" [animation]="true">
      <ng-container [ngSwitch]="searchType">
        <app-table-header-date-input
          *ngSwitchCase="TableColumnHeaderSearchType.Date"
          [controlId]="controlId"
          [formControlName]="controlId" />
        <app-table-header-text-input
          *ngSwitchCase="TableColumnHeaderSearchType.Text"
          [controlId]="controlId"
          [formControlName]="controlId" />
        <app-table-header-dropdown-input
          *ngSwitchCase="TableColumnHeaderSearchType.Dropdown"
          [controlId]="controlId"
          [dropdowns]="dropdownItems$ | async"
          [formControlName]="controlId" />
        <app-table-header-number-input
          *ngSwitchCase="TableColumnHeaderSearchType.Number"
          [controlId]="controlId"
          [formControlName]="controlId" />
      </ng-container>
    </div>
  </div>
</div>

<ng-template #noSearchHeader>
  <div class="d-flex flex-column gap-1">
    <button
      type="button"
      class="header-title no-style-button"
      [ngClass]="{ disabled: disableSort }"
      [disabled]="disableSort"
      (click)="toggleSort()">
      <span class="column-name">{{ columnName }}</span>
      <span *ngIf="isAscSort$ | async" class="visually-hidden" i18n>, sorted ascending</span>
      <span *ngIf="isDescSort$ | async" class="visually-hidden" i18n>, sorted descending</span>
      <span *ngIf="!disableSort" class="sort-arrow">
        <img *ngIf="sortIconSrc$ | async" [src]="sortIconSrc$ | async" alt="" />
        <img *ngIf="!(sortIconSrc$ | async)" [src]="'assets/icons/grey/Arrow-Down.svg'" alt="" />
      </span>
    </button>
  </div>
</ng-template>
